import { NavLinkProps } from "react-router-dom";

export const navLinkIsActive = (categoryId: string) => {
  const fn: NavLinkProps["isActive"] = (match, location) => {
    const searchParams = new URLSearchParams(location.search);
    return match?.url === location.pathname && searchParams.get("category0") === categoryId;
  };
  return fn;
};
